import React from "react";
import styled from "@emotion/styled";

import Button from "components/ui/button/Button";
import Modal from "components/ui/modal/Modal";
import { Flex, Text } from "../../../styles/utility-components";

type Props = {
  open: boolean;
  onOpenChange: (open: boolean) => void;
  discardChanges: () => void;
};

export function DiscardSelfServeModal({ open, onOpenChange, discardChanges }: Props) {
  return (
    <Modal open={open} onOpenChange={onOpenChange} showCloseButton={false}>
      <Content gap={16} flexDirection="column">
        <Text h3>About to discard changes</Text>
        <Flex gap={8} flexDirection="column">
          <Text>You have unsaved changes on this page, are you sure you want to discard them?</Text>
          <Text>This action cannot be undone.</Text>
        </Flex>
        <Flex gap={8} justifyContent="flex-end">
          <Button buttonType="secondary" onClick={() => onOpenChange(false)}>
            Keep editing
          </Button>
          <Button buttonStyle="destructive" onClick={discardChanges}>
            Discard changes
          </Button>
        </Flex>
      </Content>
    </Modal>
  );
}

const Content = styled(Flex)({
  width: 440,
  gap: 16,
  flexDirection: "column",
  padding: 16,
});
